import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enTranslation from "./locales/en/translation.json";
import frTranslation from "./locales/fr/translation.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: "en",
    fallbackLng: "en",
    supportedLngs: ["en", "fr"],
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: enTranslation,
      },
      fr: {
        translation: frTranslation,
      },
    },
    detection: {
      order: ["navigator"],
      caches: [],
    },
  });

try {
  if (typeof window !== "undefined") {
    window.__i18nSwitchLang = (lang) => {
      if (typeof lang === "string" && ["en", "fr"].includes(lang)) {
        i18n.changeLanguage(lang);
      } else {
        console.warn("Unsupported language. Use 'en' or 'fr'.");
      }
    };
  }
} catch (e) {
  console.warn("i18n language switch function is not available in this environment.");
}

export default i18n;
